/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Dictate_BlockedInputs */



/**
* | output |
* | --- |
* | "Wundo is not allowed to use your microphone. Give it access in your browser." |
*
* @param {Chat_Dictate_BlockedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_dictate_blocked = /** @type {((inputs?: Chat_Dictate_BlockedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dictate_BlockedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo mag je microfoon niet gebruiken. Geef toegang in je browser.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo n'a pas accès à votre micro. Autorisez-le dans votre navigateur.")
	return /** @type {LocalizedString} */ ("Wundo is not allowed to use your microphone. Give it access in your browser.")
});